import { render, staticRenderFns } from "./ExamPart.vue?vue&type=template&id=4520f95c"
import script from "./ExamPart.vue?vue&type=script&lang=js"
export * from "./ExamPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports